import { createContext, useState } from "react";

export const EditSizeChartContext = createContext();

export const EditSizeChartContextProvider = ({ children }) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [sizeChartName, setSizeChartName] = useState('');
    const [extraColumnKeys, setExtraColumnKeys] = useState([]);

    const [sizeChartFormData, setSizeChartFormData] = useState([]);

    const contextValue = {
        selectedCategory,
        setSelectedCategory,
        sizeChartName,
        setSizeChartName,
        sizeChartFormData,
        setSizeChartFormData,
        extraColumnKeys,
        setExtraColumnKeys
    };

    return (
        <EditSizeChartContext.Provider value={ contextValue }>
            { children }
        </EditSizeChartContext.Provider>
    );
}
